<div style="padding-top:10px">
    <form>
        <div class="form-group">
        </div>
    </form>
    <div class="panel panel-default" style="align-items: right; border: NONE">
        <button type="button" class="btn btn-xs okpanel-btn" (click)="apply(button_label)">
            {{button_label}}
        </button>
        <button type="button" class="btn btn-xs okpanel-btn" (click)="apply( 'cancel' )">
            Cancel
        </button>
    </div>
</div>